var constants = require('../constants');

var Validate = (function() {

    var _setResponseValidationError = function(error) {
        return {
            type: constants.SET_RESPONSE_VALIDATION_ERROR,
            errors: error
        };
    }

    var _clearResponseValidationError = function() {
        return {
            type: constants.CLEAR_RESPONSE_VALIDATION_ERROR
        };
    }

    return {
    	clearResponseValidationError: _clearResponseValidationError,
        setResponseValidationError: _setResponseValidationError
    }
})();

module.exports = Validate;



// WEBPACK FOOTER //
// ./src/common/modules/responses/actions/validate.js